var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04297 6.43164V19.2209C1.04297 19.6593 1.40713 20.0004 1.81985 20.0004H19.154C19.5909 20.0004 19.9308 19.635 19.9308 19.2209V6.43164H1.04297ZM14.4198 11.3281C14.4198 11.7666 14.0557 12.1076 13.643 12.1076H7.33083C6.89384 12.1076 6.55395 11.7422 6.55395 11.3281V9.74465C6.55395 9.30617 6.91811 8.96512 7.33083 8.96512H13.643C14.08 8.96512 14.4198 9.33053 14.4198 9.74465V11.3281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1988 0H0.776879C0.339884 0 0 0.365406 0 0.779533V5.38365H21V0.803893C20.9757 0.365406 20.6358 0 20.1988 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageWhite);
export default __webpack_public_path__ + "static/media/storage-white.2225303b286b6588ca3563ab25aa24cc.svg";
export { ForwardRef as ReactComponent };